<div class="container">
  @if (mergeForm) {
    <div class="mt-4">
      <form [formGroup]="mergeForm" (submit)="onSubmit()">
        <div class="row">
          <div class="col-xl-6">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title text-primary">Source</h4>
                <p class="card-text">Sélectionner le bénéficiaire source.</p>
                <div class="mb-3">
                  <input
                    type="text"
                    autocomplete="off"
                    class="form-control"
                    [class.is-invalid]="submitted && mergeForm.controls.sourceId.invalid"
                    formControlName="sourceId"
                    [ngbTypeahead]="search"
                    [editable]="false"
                    [inputFormatter]="formatter"
                    [resultTemplate]="rt"
                    [class.d-none]="mergeForm.controls.sourceId.value"
                    (selectItem)="onSelectItem($event, 'sourceId')"
                    />
                  @if (mergeForm.controls.sourceId.value) {
                    <ng-template
                      [ngTemplateOutlet]="info"
                    [ngTemplateOutletContext]="{
                      item: mergeForm.controls.sourceId.value,
                      folderSummary: sourceSummary,
                      formControlName: 'sourceId',
                      invalid: submitted && (mergeForm.controls.sourceId.invalid || sourceSummary?.rsj > 0),
                    }"
                    ></ng-template>
                  }
                  @if (submitted && mergeForm.controls.sourceId.errors?.required) {
                    <small class="text-danger">
                      La source de la fusion est obligatoire.
                    </small>
                  }
                  @if (submitted && sourceSummary?.rsj > 0) {
                    <small class="text-danger"> La source ne doit pas avoir de dossier RSJ. </small>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 mt-xl-0 mt-4">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title text-primary">Destination</h4>
                <p class="card-text">Sélectionner le bénéficiaire de destination.</p>
                <div class="mb-3">
                  <input
                    type="text"
                    autocomplete="off"
                    class="form-control"
                    [class.is-invalid]="submitted && mergeForm.controls.destId.invalid"
                    formControlName="destId"
                    [ngbTypeahead]="search"
                    [editable]="false"
                    [inputFormatter]="formatter"
                    [resultTemplate]="rt"
                    [class.d-none]="mergeForm.controls.destId.value"
                    (selectItem)="onSelectItem($event, 'destId')"
                    />
                  @if (mergeForm.controls.destId.value) {
                    <ng-template
                      [ngTemplateOutlet]="info"
                    [ngTemplateOutletContext]="{
                      item: mergeForm.controls.destId.value,
                      folderSummary: destSummary,
                      formControlName: 'destId',
                      invalid: submitted && mergeForm.controls.destId.invalid,
                    }"
                    ></ng-template>
                  }
                  @if (submitted && mergeForm.controls.destId.errors?.required) {
                    <small class="text-danger">
                      La destination de la fusion est obligatoire.
                    </small>
                  }
                  @if (submitted && mergeForm.controls.destId.errors?.noMatch) {
                    <small class="text-danger">
                      La destination de la fusion ne peut pas être identique à la source.
                    </small>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="d-grid col-12 col-xl-3 mt-4 mt-xl-4 ms-xl-auto">
            <button type="button" class="btn btn-primary" (click)="onReinit()">Réinitialiser</button>
          </div>
          <div class="d-grid col-12 col-xl-3 mt-2 mt-xl-4">
            <button type="submit" class="btn btn-primary">Fusionner</button>
          </div>
        </div>
      </form>
    </div>
  }
  <ng-template #rt let-res="result" let-t="term">
    <div class="d-flex flex-column my-1">
      <div class="d-flex justify-content-between w-100">
        <small>{{ res.id }}</small>
        <small>{{ res.birthDate | date: 'dd/MM/yyyy' }}</small>
      </div>
      <ngb-highlight [result]="(res.lastName ? res.lastName + ' ' : '') + res.firstName" [term]="t"> </ngb-highlight>
    </div>
  </ng-template>
  <ng-template #info let-item="item" let-formControlName="formControlName" let-invalid="invalid" let-folderSummary="folderSummary">
    <div class="mt-2 alert alert-dismissible fade show" [class.alert-dark]="!invalid" [class.alert-danger]="invalid">
      <div class="d-flex justify-content-between align-items-center">
        <small
          ><strong>{{ item.id }}</strong></small
          >
          <button aria-label="Close" class="btn btn-icons p-0" type="button" (click)="onClosed(formControlName)">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="d-flex justify-content-between">
          <p class="mb-0">{{ (item.lastName ? item.lastName + ' ' : '') + item.firstName }}</p>
          <small>{{ item.birthDate | date: 'dd/MM/yyyy' }}</small>
        </div>
        @if (folderSummary) {
          <ng-template [ngTemplateOutlet]="summary" [ngTemplateOutletContext]="{ summary: folderSummary }"> </ng-template>
        }
      </div>
    </ng-template>
    <ng-template #summary let-summary="summary">
      <div class="mt-1">
        <hr />
        <div class="d-flex justify-content-between">
          <span>Contrats :</span><strong>{{ summary.contracts | number }}</strong>
        </div>
        <div class="d-flex justify-content-between">
          <span>Contacts :</span><strong>{{ summary.interviews | number }}</strong>
        </div>
        <div class="d-flex justify-content-between">
          <span>Étapes :</span><strong>{{ summary.stages | number }}</strong>
        </div>
        <div class="d-flex justify-content-between">
          <span>Questionnaires FSE :</span><strong>{{ summary.surveyFSEs | number }}</strong>
        </div>
        <div class="d-flex justify-content-between">
          <span>Diagnostics :</span><strong>{{ summary.assessments | number }}</strong>
        </div>
        <div class="d-flex justify-content-between">
          <span>Documents :</span><strong>{{ summary.documents | number }}</strong>
        </div>
        <div class="d-flex justify-content-between">
          <span>Dossier RSJ :</span><strong>{{ summary.rsj | number }}</strong>
        </div>
      </div>
    </ng-template>
  </div>
